import gql from 'graphql-tag';

export const query = gql([
    `
query FindListeVoyageContent($id: String!) {
  findListeVoyageContent(id: $id) {
    data {
      title { iv }
      subTitle { iv }
      fontSizeTitle { iv }
      fontSizeSubTitle { iv }
      width { iv }
      tagline { iv }
      textColor { iv }
      color { iv }
      ctaLink { iv }
      ctaText { iv }
      ctaStyle { iv }
      ctaLink2 { iv }
      ctaText2 { iv }
      ctaStyle2 { iv }
      picture {
        iv {
          url
          fileSize
        }
      }
      horizontalPosition { iv }
      justification { iv }

      tcb1BackgroundColor { iv }
      tcb1TextColor { iv }
      tcb1Title { iv }
      tcb1FontSizeTitle { iv }
      tcb1Subtitle { iv }
      tcb1FontSizeSubtitle { iv }
      tcb1CtaText1 { iv }
      tcb1CtaLink1 { iv }
      tcb1CtaStyle1 { iv }
      tcb1CtaText2 { iv }
      tcb1CtaLink2 { iv }
      tcb1CtaStyle2 { iv }
      tcb1CtaText3 { iv }
      tcb1CtaLink3 { iv }
      tcb1CtaStyle3 { iv }

      carrouselVisuels1 { iv { id } }
      
      tcb2BackgroundColor { iv }
      tcb2TextColor { iv }
      tcb2Title { iv }
      tcb2FontSizeTitle { iv }
      tcb2Subtitle { iv }
      tcb2FontSizeSubtitle { iv }
      tcb2CtaText1 { iv }
      tcb2CtaLink1 { iv }
      tcb2CtaStyle1 { iv }
      tcb2CtaText2 { iv }
      tcb2CtaLink2 { iv }
      tcb2CtaStyle2 { iv }
      tcb2CtaText3 { iv }
      tcb2CtaLink3 { iv }
      tcb2CtaStyle3 { iv }

      formMentions { iv }

      carrouselVisuels2 { iv { id } }

      mentions { iv }

      seoDescription { iv }
      seoKeywords { iv }
      seoThumbnail {
        iv {
          url
        }
      }
    }
  }
}
`,
]);
